export const createQueuedUploadStatuses = (filesToUpload) => {
  return filesToUpload.reduce((statusesByUploadKey, fileItem) => {
    statusesByUploadKey[fileItem.uploadKey] = 'queued';
    return statusesByUploadKey;
  }, {});
};
